import React, { Component } from "react";
import { Avatar, Divider } from "@mui/material";
import { Box } from "@mui/system";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import { IconButton } from "@mui/material";
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import Stack from "@mui/material/Stack";



export class TransactionItem extends Component {
  constructor(props) {
    super(props);
    this.state = {
      transaction: {},
    };
  }

  static defaultProps = {
    handleClick: null

  }

  render() {
    return (
      <>
        <Grid
          container
          mt={1}
          mb={2}
          justifyContent="space-between"
          alignItems="flex-end"
          className={this.props.transaction.amount === null ? "blur" : ""}
        >
          <Grid item>
            <Typography variant="body2" fontWeight={700} mb={1} color="text.secondary">
              {this.props.transaction.date} <Typography color="text.secondary" display={"inline"}
                textAlign="right"
                variant="body2" sx={{ marginLeft: "15px" }}>{this.props.transaction.date_label}</Typography>
            </Typography>
            <Grid container alignItems="center">
              <Grid item mr={1.5}>
                <Avatar sx={{ backgroundColor: "grey.100" }}>
                  <Box sx={{ fontWeight: "bold" }} color="primary.main">
                    {this.props.transaction.text.slice(0, 1)}
                  </Box>
                </Avatar>
              </Grid>
              <Grid item>
                <Typography variant="body1">
                  {this.props.transaction.text}
                </Typography>
                {this.props.transaction.category ?
                  <Typography variant="subtitle2" color="text.secondary">
                    {this.props.transaction.category}
                  </Typography> : ""
                }

              </Grid>
            </Grid>
          </Grid>
          <Grid item>
            <Stack direction="row" alignItems="center">
              <Grid item justifyContent={"end"}>
                <Typography
                  variant="h5"
                  marginBottom={0}
                  display="flex"
                  fontSize="1rem"
                  fontWeight={500}
                  justifyContent={"end"}
                  sx={{ marginBottom: this.props.transaction.price_label === "" || this.props.transaction.price_label === null ? "8px" : "0px" }}
                  flexDirection={this.props.prefix === "£" ? "row-reverse" : "row"}
                >
                  {
                    this.props.co2DataPresent === true ?
                      <span style={{ fontSize: "1rem", fontWeight: 500 }}>
                        {
                          this.props.prefix === "£" && this.props?.transaction?.amount != null ?
                            parseFloat(this.props?.transaction?.amount).toFixed(2) :
                            this.props.prefix === "kg" && this.props?.transaction?.amount_co2 != null ?
                              parseFloat(this.props?.transaction?.amount_co2).toFixed(2) :
                              " - "
                        }
                      </span> :
                      <span style={{ fontSize: "1rem", fontWeight: 500, textAlign: "right" }}>
                        {
                          this.props?.transaction?.amount != null ?
                            parseFloat(this.props?.transaction?.amount).toFixed(2) :
                            " - "
                        }

                      </span>
                  }

                  <span>{this.props.prefix}</span>
                </Typography>
                <Typography
                  color="text.secondary"
                  textAlign="right"
                  variant="body2"
                >
                  {this.props.transaction.price_label}
                </Typography>
              </Grid>
              {
                this.props.handleItemClick ?
                  <IconButton sx={{ flexGrow: 1, height: '3rem', width: "3rem", marginLeft: "4px", paddingRight: 0, marginRight: "-4px" }} color="primary" aria-label="Edit Transaction" component="div" onClick={() => this.props.handleItemClick(this.props.transaction)}>
                    <ChevronRightIcon />
                  </IconButton>
                  : null
              }
            </Stack>
          </Grid>

        </Grid>
        <Divider light />
      </>
    );
  }
}

export default TransactionItem;